import { CurrenciesInterface } from "../pages/Settings/data";
import { currencies } from "currencies.json";

type AllCurrenciesType = {
  list: CurrenciesInterface[];
  data: CurrenciesInterface[];
  crypto: CurrenciesInterface[];
  item: { [key: string]: CurrenciesInterface };
};
export const getAllCurrencies = async (): Promise<AllCurrenciesType> => {
  const item: AllCurrenciesType["item"] = {};
  const list = currencies?.map((data: any) => {
    const props = {
      ...data,
      label: data.name,
    };
    item[data.code] = props;
    return props;
  }) as CurrenciesInterface[];
  return {
    list,
    data: list.filter(({ type }: any) => type === "fiat"),
    crypto: list.filter(({ type }: any) => type === "crypto"),
    item,
  };
};
